import React, {Fragment} from 'react';
import {useDashboardEventStyle} from "../../CustomHooks";
import ReactTooltip from "react-tooltip";
import BigCalendar from "react-big-calendar";

class PureBigCalendar extends React.PureComponent {
    constructor (props) {
        super(props);
    }


    render() {
        return (
            <BigCalendar
                events={this.props.events}
                onNavigate={this.props.onNavigate}
                startAccessor='startDate'
                endAccessor="endDate"
                onSelectSlot={(slotInfo) => {
                    if (slotInfo && slotInfo.slots.length) {
                        this.props.onSelectSlot(slotInfo)
                    }
                }}
                onSelectEvent={event => {
                    this.props.onSelectEvent(event)
                }}
                selectable={true}
                views={{ month: true, week: true, day: true }}
                defaultView='month'
                defaultDate={this.props.defaultDate}
                longPressThreshold={250}
                eventPropGetter={useDashboardEventStyle}
                timeslots={8}
                popup={true}
                components={{
                    month: {
                        dateHeader: (props) => this.props.renderEventHeader(props),
                        event: (props) => {
                            return (
                                <div className="rbc-row-segment">
                                    <div
                                        className={`rbc-event case-type ${props.event.type === 'prototype' ? 'prototype-case' : props.event.type === 'temp' ? 'temp-case' : props.event.type === 'ceramic' ? 'ceramic-case' : props.event.type === 'other' ? 'other-case' : 'zirconia-case'}`}>
                                        <div className="type-block">
                                            <div
                                                className="rbc-event-content text-left"
                                                title={props.event.title}>
                                                {props.event.title}</div>
                                            <div className="rbc-event-number"
                                                 style={{textAlign: 'right'}}
                                                 title="Number of units">{props.event.numberOfUnits}</div>
                                            <ReactTooltip place="top" type="light"
                                                          effect="float"/>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    },
                    week: {
                        header: (props) => this.props.renderEventHeader(props),
                        event: (props) => {
                            return (
                                <div className="rbc-row-segment">
                                    <div
                                        className={`rbc-event case-type ${props.event.type === 'prototype' ? 'prototype-case' : props.event.type === 'temp' ? 'temp-case' : props.event.type === 'ceramic' ? 'ceramic-case' : props.event.type === 'other' ? 'other-case' : 'zirconia-case'}`}>
                                        <div className="type-block">
                                            <div
                                                className="rbc-event-content text-left"
                                                title={props.event.title}>
                                                {props.event.title}</div>
                                            <div className="rbc-event-number"
                                                 style={{textAlign: 'right'}}
                                                 title="Number of units">{props.event.numberOfUnits}</div>
                                            <ReactTooltip place="top" type="light"
                                                          effect="float"/>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    },
                    day: {
                        header: (props) => this.props.renderEventHeader(props),
                        event: (props) => {
                            return (
                                <div className="rbc-row-segment day">
                                    <div
                                        className={`rbc-event case-type ${props.event.type === 'prototype' ? 'prototype-case' : props.event.type === 'temp' ? 'temp-case' : props.event.type === 'ceramic' ? 'ceramic-case' : props.event.type === 'other' ? 'other-case' : 'zirconia-case'}`}>
                                        <div className="type-block">
                                            <div
                                                className="rbc-event-content text-left"
                                                title={props.event.title}>
                                                {props.event.title}</div>
                                            <div className="rbc-event-number"
                                                 style={{textAlign: 'right'}}
                                                 title="Number of units">{props.event.numberOfUnits}</div>
                                            <ReactTooltip place="top" type="light"
                                                          effect="float"/>
                                        </div>
                                    </div>
                                </div>
                            )
                        }
                    }
                }}
            />
        );
    }

}

export default PureBigCalendar



// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/dashboard/PureBigCalendar.js